import { type ReactNode } from 'react';
import { SingleSelect } from '@/ui_v3/components/select';
interface QuoteSelectOption {
  value: string;
  label: ReactNode;
}
interface QuoteSelectFieldProps {
  label: string;
  value: string;
  options: QuoteSelectOption[];
  onValueChange: (value: string | null) => void;
  placeholder?: string;
}

/** 라벨 + SingleSelect (Figma "Select" — 사용 기간 등, 재사용). */
export function QuoteSelectField({
  label,
  value,
  options,
  onValueChange,
  placeholder
}: QuoteSelectFieldProps) {
  return <div className="flex w-full flex-col gap-3xs" data-sentry-component="QuoteSelectField" data-sentry-source-file="QuoteSelectField.tsx">
      <span className="text-body-lg-bold text-default">{label}</span>
      <SingleSelect<string> options={options} value={value} onValueChange={onValueChange} placeholder={placeholder} className="w-full" data-sentry-element="SingleSelect" data-sentry-source-file="QuoteSelectField.tsx" />
    </div>;
}